import { render } from "./PageBody.vue?vue&type=template&id=15fbc47b&scoped=true"
import script from "./PageBody.vue?vue&type=script&lang=js"
export * from "./PageBody.vue?vue&type=script&lang=js"

import "./PageBody.vue?vue&type=style&index=0&id=15fbc47b&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fbc47b"]])

export default __exports__